module.exports = __webpack_public_path__ + "static/media/README.3b4254e6.md";